import React, { Component } from 'react';
import './Prompt.sass'

class Prompt extends Component {
	render() {
		return (
			<div className="prompt">
				<h4>Prompt {this.props.index}</h4>
				<p>{this.props.value}</p>
			</div>
		);
	}
}

export default Prompt;
